import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../lang/LangEnum';
import { OrderView } from '../../modules/orders/ordersView.types';
import { useTranslation } from '../../modules/translation/TranslationContext';
import useGeneralSettingsStore from '../../stores/GeneralSettings/useGeneralSettingsStore';
import useOrderBookStore from '../../stores/OrderBook/orderBook.store';
import useProductActionsStore from '../../stores/ProductActionsStore/productActions.store';
import useWidth from '../Hooks/useWidth';
import ProductNotificationSnackbar from './ProductNotificationSnackbar';
import { useProductNotificationStyles } from './styles/ProductNotificationStyles';

const ProductAlreadyAdded: React.FC = () => {
  const {
    productNotificationState,
    closeProductNotification,
    setNotificationTimerIsValid,
    setScrollToProduct,
  } = useProductActionsStore(
    useShallow((state) => ({
      productNotificationState: state.productNotificationState,
      closeProductNotification: state.closeProductNotification,
      setNotificationTimerIsValid: state.setNotificationTimerIsValid,
      setScrollToProduct: state.setScrollToProduct,
    })),
  );

  const selectedOrder = useOrderBookStore((state) => state.selectedOrder);
  const history = useHistory();
  const { translate } = useTranslation();
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);
  const { classes } = useProductNotificationStyles({ mediaFormat });
  const { mobileWidth } = useWidth();

  const id = productNotificationState.productAlready ? 'simple-snackbar' : undefined;
  const valueOfX = mobileWidth ? 14 : 0;
  const newValueOfX = productNotificationState.productAlready ? valueOfX : 400;

  const handleRedirectToOrder = () => {
    if (!selectedOrder) {
      return;
    }

    history.push(`/orders/${selectedOrder?.id}/${OrderView.EDIT}`);
    setNotificationTimerIsValid(true);
    setScrollToProduct(true);
  };

  return (
    <ProductNotificationSnackbar
      id={id}
      open={productNotificationState.productAlready}
      onClose={closeProductNotification}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      className={classes.productAlreadySnackbar}
      initial={{ opacity: 0, x: 400, y: 0 }}
      animate={{ opacity: 1, x: newValueOfX, y: 0 }}
      exit={{ opacity: 0, x: 400, y: 0 }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {productNotificationState.productColorId
            ? translate(LangEnum.PRODUCT_NOTIFICATION_ALREADY_ADDED)
            : translate(LangEnum.PRODUCT_KIT_NOTIFICATION_ALREADY_ADDED)}
        </Typography>
        <Button variant="text" color="primary" size="small" onClick={handleRedirectToOrder}>
          {translate(LangEnum.PRODUCT_NOTIFICATION_VIEW_ON_ORDER)}
        </Button>
      </Stack>
    </ProductNotificationSnackbar>
  );
};

export default ProductAlreadyAdded;
